export type ProductComparisonSegmentTypeIndex = 'business' | 'consumer' | 'mixed';
export type ProductComparisonSegmentTypeName = 'Business' | 'Consumer' | 'Mixed';
export const ProductComparisonSegmentType: Readonly<Record<ProductComparisonSegmentTypeName, ProductComparisonSegmentTypeIndex>> = {
  Business: 'business',
  Consumer: 'consumer',
  Mixed: 'mixed',
};
